import { render, staticRenderFns } from "./school-selector.vue?vue&type=template&id=a1a4ed0e"
import script from "./school-selector.vue?vue&type=script&lang=ts"
export * from "./school-selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports